import { useState } from "react";

const framesData = [
  {
    title: "Metal Frames",
    img: "/images/frames/metal.jpg",
    best: true,
  },
  {
    title: "Rimless Frames",
    img: "/images/frames/rimless.jpg",
    best: true,
  },
  {
    title: "Fiber Frames",
    img: "/images/frames/fiber.jpg",
    best: false,
  },
  {
    title: "Kids Frames",
    img: "/images/frames/kids.jpg",
    best: false,
  },
];

const OpticalFrames = () => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section className="section">
      <div className="container">
        <h2>Optical Frames</h2>
        <p className="section-subtitle">
          Metal, fiber & rimless frames for all face types.
        </p>

        <div className="grid">
          {framesData.map((item, index) => (
            <div className="card image-card" key={index}>
              {item.best && <span className="badge">Best Seller</span>}

              <img
                src={item.img}
                alt={item.title}
                className="service-image clickable"
                onClick={() => setActiveImage(item.img)}
              />

              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* IMAGE GALLERY MODAL */}
      {activeImage && (
        <div className="lightbox" onClick={() => setActiveImage(null)}>
          <img src={activeImage} alt="Preview" />
          <span className="close">×</span>
        </div>
      )}
    </section>
  );
};

export default OpticalFrames;
